import { PliValue } from './pli-value';
import { PliAverage } from './pli-average';

export class Pli {
  pliValues: PliValue[];
  pliAverages: PliAverage[];
}
